/**
 * Test Environment Configuration
 * Used for provisioning-admin-test.in.strong.blue
 */

export const testConfig = {
  environment: 'test',
  hostname: 'provisioning-admin-test.in.strong.blue',

  api: {
    baseUrl: '/api',
    firmwareBaseUrl: 'http://provisioning-test.in.strong.blue',
  },

  oauth: {
    clientId: 'provisioning-dev',
    redirectUri: 'https://provisioning-admin-test.in.strong.blue/auth/callback',
    authUrl: 'https://sso.strong.blue/realms/anep-dev/protocol/openid-connect/auth',
    tokenUrl: 'https://sso.strong.blue/realms/anep-dev/protocol/openid-connect/token',
  },

  ui: {
    title: 'StrongBlue Device Provisioning [TEST]',
    logoUrl: '/logo.jfif',
    companyName: 'Strong Blue',
    primaryColor: '#215EA1',
  },

  dev: {
    debug: true, // Enable debug in test environment
  },
} as const;

export default testConfig;